<template>
    <Typography
        is="div"
        type="paragraph"
        size="xs"
        :class="$style.copyright_override"
    >
        {{ $tr('navigation.copyright', { year: String(new Date().getFullYear()) }) }}
    </Typography>
</template>

<script setup lang="ts">
import Typography from '@/components_new/Typography.vue'
</script>
<style module>
.copyright_override {
    color: var(--white-40);
}
</style>
